import React from 'react';
import './StackSelectionComponent.css';

const StackSelectionComponent = ({ 
  asset, 
  label, 
  onClick, 
  width, 
  height 
}) => {
  return (
    <div className="stack-selection-container">
      <div 
        className="stack-selection-wrapper"
        style={{ width: width, height: height }}
      >
        <div className="stack-selection-inner">
          <div 
            className="stack-selection-button"
            onClick={onClick}
          >
            <div className="stack-selection-content">
              <div className="stack-selection-icon">
                <img 
                  src={asset || "/assets/images/food_plater.png"} 
                  alt={label}
                  className="stack-selection-image"
                />
              </div>
              <div className="stack-selection-label">
                {label}
              </div>
              <div className="stack-selection-arrow">
                <span className="arrow-icon">→</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StackSelectionComponent;